export class UpdateUser {
    constructor(userRepository) {
      this.userRepository = userRepository;
    }
  
    async execute(user) {
        console.log("update user repository", user)
      return await this.userRepository.updateUser(user);
    }
  }